import { distance, bivariateColor } from "../Utils";
import { MIN_YEAR, MAX_YEAR, GRI_BREAKS, SHI_BREAKS, MOBILE_WIDTH, OFFSCREEN_Y, OFFSCREEN_X, DPR, INDEX_LABELS, REGIONS} from "../Constants";
import * as d3 from "d3";

// need to have a minimum number of 11 nodes to display 10 years

export default class ScatterplotLayout {
	constructor(type="scatter", nodes, count, model, width, height, offset_x=0, offset_y=0, min_year= MIN_YEAR){
		this.type = type;
		this.nodes = nodes;
		this.alternate = document.querySelector('#map').classList.contains('step-99');
		this.model = model;
		this.iso = type === 'scatter' ? this.nodes[0].iso : undefined;
		this.initial_year = min_year;
		this.year = min_year;
		this.timer = d3.timer( () => this.timer.stop());
		this.tooltip = null;
		this.setDimensions(width, height, offset_x, offset_y);

		if ( type === 'scatter' ) {
			this.coordinates = new Array(count);
			for (let i =0; i < this.nodes.length; i++ ){
				this.nodes[i].scale.set(this.minSize, this.minSize);
			}
		}

		this.drawLabels();
		this.drawAxes();
		this.x_force = d3.forceX( d => { return this._coordinates_x(d.id)|| OFFSCREEN_X }).strength(0);
		this.y_force = d3.forceY( d => { return this._coordinates_y(d.id) || OFFSCREEN_Y }).strength(0);
	}
	setDimensions(width, height, offset_x, offset_y){
		let canvas = document.querySelector("#map canvas");
		let _width = canvas.width/DPR;
		this._width = _width;
		let _height = canvas.height/DPR;
		this.aspect_ratio = this._width / _height;
		this.margin = _width < MOBILE_WIDTH ? {top: 0, right:20, bottom: 50, left: 30} : this.alternate ? {top: 0, right: 0, bottom: 50, left: 75} : {top: 0, right: 0, bottom: 50, left: 50};
		this.svg_margin =  _width < MOBILE_WIDTH  && this.alternate ? {top: _width/10, left: _width/2 - (this.margin.left - 5)}:
			this.alternate && ~["156", "356"].indexOf(this.iso) && this.aspect_ratio >= 2 ? {top: (_height - height), left : (_width/3 - width)/2.6}:
			this.alternate && ~["156", "356"].indexOf(this.iso) ? {top: (_height - height) + 30, left : (_width/3 - width)/2 - 5}:
			this.alternate  && this.aspect_ratio >= 2 ? {top: (_height - height), left : (_width/3 - width)/2}:
			this.alternate ? {top: (_height - height)/1.2 , left : (_width/3 - width)/2}:
			_width < MOBILE_WIDTH ? {top: 20, left: 0}:
			{top: (_height - height)/2  + this.margin.bottom/2, left: (_width/2 - width)/2 };
		this.width = width - this.margin.right - this.margin.left;
		this.height = height - this.margin.top - this.margin.bottom;
		this.offset_x = offset_x + this.margin.left + this.svg_margin.left;
		this.offset_y = offset_y + this.margin.top + this.svg_margin.top;
		this.minSize = width > 500 && !this.alternate ? .75 : 0.75;
		this.maxSize = width > 500 && !this.alternate ? 1.2 : 1.2;
	}
	drawLabels(){
		this.labels = document.createDocumentFragment();
		this.title_element = document.createElement('span');
		this.title_element.setAttribute('id', `label--${this.iso}`);
		this.title_element.setAttribute('class', `label`);
		this.title_element.setAttribute('style', `top:${this._width < MOBILE_WIDTH ? 0 : this.alternate ? this.svg_margin.top - 50 : this.svg_margin.top - this.svg_margin.top * .4}px;left:${this.alternate ? this.svg_margin.left : this.svg_margin.left + 80 }px;`);
		this.title_element.setAttribute('data-top', `${this._width < MOBILE_WIDTH ? 0 : this.alternate ? this.svg_margin.top - 50 : this.svg_margin.top - this.svg_margin.top * .4}`);
		this.labels.appendChild(this.title_element.cloneNode(true));
		this.title_element.setAttribute('class', `title`);
		this.title_element.replaceChildren(this.title());
	}
	drawAxes() {
		this.axes = document.createDocumentFragment();
		this.axes.appendChild(this.title_element.cloneNode(true));
		this.x_scale = d3.scaleLinear().domain([0,10]).range([0, this.width]);
		this.y_scale = d3.scaleLinear().domain([0,10]).range([this.height, 0]);
		this.x_labels = d3.scaleThreshold().domain(GRI_BREAKS).range(INDEX_LABELS);
		this.y_labels = d3.scaleThreshold().domain(SHI_BREAKS).range(INDEX_LABELS);
		this.x_axis = d3.axisBottom(this.x_scale).tickValues(GRI_BREAKS).tickSize(-this.height).tickFormat(d3.format(".1f"));
		this.y_axis = d3.axisLeft(this.y_scale).tickValues(SHI_BREAKS).tickSize(-this.width).tickFormat(d3.format(".1f"));
		this.svg = d3.select(this.axes).append("svg")
			.attr('id', 'chart')
    	.attr("width", this.width + this.margin.left + this.margin.right)
    	.attr("height",this.height + this.margin.top + this.margin.bottom)
			.attr('style', `top:${this.svg_margin.top}px;left:${this.svg_margin.left}px`)
  		.append("svg:g")
			.attr("transform", `translate(${this.margin.left},${this.margin.top})`);
		this.svg_x_axis = this.svg.append("svg:g")
      .attr("class", "x axis")
      .attr("transform", `translate(0,${this.height})`)
      .call(this.x_axis)
      		.attr("class", "gri")
			.style("stroke-dasharray", "2,2")
			.style("color", "#ccc");``
    this.svg_x_axis.append("svg:text")
      .attr("class", "svg-label gri")
      .attr("x", this.width/2)
      .attr("y", this.margin.bottom/2)
      .style("text-anchor", "middle")
			.style("font-weight", 500)
      .text(`${this.alternate ? 'GRI' : 'GOVERNMENT RESTRICTIONS'}`);
		this.svg_x_axis .append("svg:text")
				.attr("class", "svg-label gri")
				.attr("x", this.width)
				.attr("y", this.margin.bottom/2)
				.style("text-anchor", "end")
				.text("VERY HIGH");
		this.svg_x_axis .append("svg:text")
				.attr("class", "svg-label both")
				.attr("x", -this.margin.left/2)
				.attr("y", this.margin.bottom/2)
				.style("text-anchor", "start")
				.text("LOW");
		this.svg_x_axis .append("svg:text")
				.attr("class", "svg-label gri")
				.attr("x", -this.margin.left/2 + 40)
				.attr("y", this.margin.bottom/2)
				.style("text-anchor", "start")
				.text("\u2192");

	  this.svg_y_axis = this.svg.append("svg:g")
	      .attr("class", "y axis")
	      .call(this.y_axis)
	      		.attr("class", "shi")
				.style("stroke-dasharray", "2, 2")
				.style("color", "#ccc");
	   this.svg_y_axis.append("svg:text")
	      .attr("class", "svg-label shi")
	      .attr("transform", "rotate(-90)")
	      .attr("y", -this.margin.left/2)
				.attr("x", -this.height/2)
	      .attr("dy", ".71em")
	      .style("text-anchor", "middle")
				.style("font-weight", 500)
	      .text(`${this.alternate ? 'SHI' : 'SOCIAL HOSTILITIES'}`);
		this.svg_y_axis.append("svg:text")
				.attr("class", "svg-label shi")
	      .attr("transform", "rotate(-90)")
	      .attr("y", -this.margin.left/2)
				.attr("x", 0)
	      .attr("dy", ".71em")
				.style("text-anchor", "end")
				.text("VERY HIGH");
		this.svg_y_axis.append("svg:text")
				.attr("class", "svg-label shi")
				.attr("transform", "rotate(-90)")
				.attr("y", -this.margin.left/2 + 7)
				.attr("x", -this.height + 10)
				.style("text-anchor", "end")
				.text("\u2192");
		this.svg.selectAll(".domain").remove();
		this.wave_holder = document.createElement('div');
		this.wave_holder.setAttribute('class', 'wave-holder');
		this.axes.appendChild(this.wave_holder);

	}
	_coordinates_x(id, offset=true) {
		return typeof this.coordinates[id] == 'undefined' ? undefined : this.coordinates[id].x + ( (!!offset) ? this.offset_x : 0);
	}
	_coordinates_y(id, offset=true) {
		return typeof this.coordinates[id] == 'undefined' ? undefined : this.coordinates[id].y + ( (!!offset) ? this.offset_y : 0);
	}
	title() {
			return new DOMParser().parseFromString(`<span>&larr;</span>`, 'text/html').body.firstChild;
	}
	makeLabel(gri, shi, _class, text) {
		const el = document.createElement('span');
		el.setAttribute('class', _class);
		el.setAttribute('style', `top:${this.y_scale(shi) + this.svg_margin.top + this.margin.top - ( this._width < MOBILE_WIDTH ? 20 : 0)}px;left:${this.x_scale(gri)+ this.svg_margin.left +this.margin.left}px;`);
		el.textContent = `${text}`;
		return el;
	}

	hitBox(iso, gri, shi, region){
		const el = document.createElement('span');
		el.setAttribute('class', 'hitbox');
		el.setAttribute('data-iso', iso);
		el.setAttribute('data-year', this.year);
		el.setAttribute('data-region', region);
		el.setAttribute('data-x', this.x_scale(gri)+ this.svg_margin.left+this.margin.left);
		el.setAttribute('data-y', this.y_scale(shi) + this.svg_margin.top + this.margin.top);
		el.setAttribute('style', `top:${this.y_scale(shi) + this.svg_margin.top + this.margin.top -3}px;left:${this.x_scale(gri)+ this.svg_margin.left+this.margin.left-3}px;`);
		return el;
	}

	layout(animate=true) {
		if (this.year > MAX_YEAR ) return;
		let gri = this.model.get(this.iso, "gri", this.year);
		let shi = this.model.get(this.iso, "shi", this.year);
		let tint = bivariateColor(gri, shi);
		for (let i = 0; i < this.nodes.length; i++ ) {
			this.nodes[i].alpha = 1;
			if (i >= this.year - MIN_YEAR ) {
				if (this.year < this.initial_year) {
					this.nodes[i].tint = REGIONS[this.model.getRegion(this.iso)];
				} else {
					this.nodes[i].tint = REGIONS[this.model.getRegion(this.iso)];//tint;
				}
				this.coordinates[this.nodes[i].id] = {x: this.x_scale(gri), y: this.y_scale(shi)};
				if (i == this.nodes.length - 1 && animate) {
					if (typeof this.timer != 'undefined') this.timer.stop();
					this.timer = d3.timer ( elapsed => {
						let t = d3.easeBounceOut(elapsed/350);
						let scale = this.minSize * ( 1 - t ) + this.maxSize * t;
						this.nodes[i].scale.set(scale);
						if (elapsed >= 350) {
							this.timer.stop();
						}
					});
				} else {
					this.nodes[i].scale.set(0.1);
				}
			} else {
				this.nodes[i].scale.set(this.minSize);
			}
		}

		let point1 = {	x: this._coordinates_x(this.nodes[this.nodes.length -1].id, false),
										y: this._coordinates_y(this.nodes[this.nodes.length -1].id, false)
									};
		let point2 = {	x: this._coordinates_x(this.nodes[Math.max( 0, this.year - MIN_YEAR - 1) ].id, false),
										y: this._coordinates_y(this.nodes[Math.max( 0, this.year - MIN_YEAR - 1) ].id, false)
									};
		let dist = distance( point1, point2);

		if (dist > 5) {
			this.svg.append("svg:path")
				.attr("d", `M ${point1.x} ${point1.y} L ${point2.x} ${point2.y}`)
				.attr("stroke", "#ccc")
				.attr("stroke-width", "1px");
		}

		this.axes.appendChild(this.hitBox(this.iso,gri,shi, REGIONS[this.model.getRegion(this.iso)]));
		const d1 = document.createElement('div');
		d1.setAttribute('class', 'waves');
		d1.setAttribute('style', `top:${point1.y+ this.svg_margin.top + this.margin.top}px;left:${point1.x+ this.svg_margin.left + this.margin.left}px;background: #${Math.abs(tint).toString(16)} !important;`);
		this.wave_holder.appendChild(d1);
		this.axes.querySelector(`[id^='label--${this.iso}']`).replaceChildren(this.title());
	}
}
